module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"sent":"送信しました。","fail_to_send":"送信に失敗しました。","sending":"送信中です..."}}')
  delete Component.options._Ctor
}
